import { useNavigate } from "react-router-dom";
import { goToSignInLanding } from "../utils/navigationUtils";

const useSignInNavigation = () => {
  const navigate = useNavigate();

  const navigateToSignInLanding = () => {
    goToSignInLanding(navigate);
  };

  return { navigateToSignInLanding };
};

export default useSignInNavigation;
